import Phaser from 'phaser'
import { WORD_BOX_STYLE } from "../constants/game";


const createBox = (key, context, color, BOX_CONFIG) => {
    var graphics = context.make.graphics(0, 0);

    graphics.fillStyle(color, WORD_BOX_STYLE.fillOpacity)
        .lineStyle(WORD_BOX_STYLE.borderSize, WORD_BOX_STYLE.borderColor, WORD_BOX_STYLE.borderOpacity)
        .fillRoundedRect(0,
            0,
            BOX_CONFIG.width,
            BOX_CONFIG.height, BOX_CONFIG.borderRadius)

        .strokeRoundedRect(0,
            0,
            BOX_CONFIG.width + WORD_BOX_STYLE.borderSize * 2,
            BOX_CONFIG.height, BOX_CONFIG.borderRadius);

    graphics.generateTexture(key, BOX_CONFIG.width, BOX_CONFIG.height);

    graphics.destroy();

}
function LetterComponent(context, letter) {
    const mediatype = context.data.get('mediaType') || 'mobile';
    const fontStyle = WORD_BOX_STYLE.fontStyle[mediatype]
    const size = parseInt(fontStyle.fontSize);
    const padding = WORD_BOX_STYLE.padding;

    const hexBackgroundColor = "#" + WORD_BOX_STYLE.backgroundColor.toString(16).padStart(6, "0");
    // const rectSize = size + Math.max(padding.x, padding.y) * 2;// para la prox se desajustas

    const bg = context.add.sprite(0, 0, 'bg-box-default');
    bg.setOrigin(0)
        .setDepth(1)
        .redraw = (state) => {
            bg.setTexture('bg-box-' + state);
        };

    const text = context.add.text(
        padding.x*2,
        padding.y,
        letter.toUpperCase(),
        fontStyle
    ).setOrigin(0).setDepth(2);



    this.width = size + padding.x * 2 + WORD_BOX_STYLE.borderSize;
    this.height = size + padding.y * 2 + WORD_BOX_STYLE.borderSize;


    const whiteshadow = context.add.image(this.width / 2, this.height / 2, "word-shadow-particle");
    whiteshadow.setOrigin(0.5)
    whiteshadow.setDepth(0)
    whiteshadow.alpha = 0;
    whiteshadow.setScale(0);
    whiteshadow.setBlendMode(Phaser.BlendModes.ADD);
    this.container = context.add.container(0, 0, [whiteshadow, bg, text]);
    this.container.text = text;


    this.getBlur = () => {
        return whiteshadow;
    }

    this.setState = (state) => {
        bg.redraw(state ? "default" : "alter");
        text.setColor(state ? fontStyle.color : hexBackgroundColor);
    }
}

function BlinkManager(letterList, tweens) {

    const blurList = letterList.map((letter) => letter.getBlur());

    const ANIMATIONS = {
        active: {

            targets: blurList,
            alpha: .2,
            scale: 1.2,
            duration: 500,
            ease: 'Linear',
            easeParams: [0.4, 0.5]
        },
        inactive: {

            targets: blurList,
            alpha: 0,
            scale: 0,
            duration: 500,
            ease: 'Linear',
            easeParams: [0.4, 0.5]
        },
        get: function (state) {
            return this[state ? "active" : "inactive"];
        }
    }

    var blinking = false;
    var blink_times = 0;
    var blink_state = false;
    const animateBlur = (state) => {

        return new Promise((complete) => {
            tweens.add(ANIMATIONS.get(state)).on('complete', complete)
        })

    }
    const doblinking = () => {

        if (blink_times <= 0) {
            blinking = false;
        }

        if (!blinking) {
            blink_state = false;
            animateBlur(false);
            return
        }
        blink_state = !blink_state;
        blink_times--;

        letterList.forEach((letter) => {
            letter.setState(blink_state)
        })

        animateBlur(blink_state).then(doblinking);
    }
    this.blink = (times = Infinity) => {
        blinking = true;
        blink_times = times;
        doblinking();
    };
    this.blinkStop = () => {
        blinking = false;
    }
    this.blinkOnce = () => {
        this.blink(1)
    }
    this.highlight = (state = true) => {
        animateBlur(state);
    }
}

function WordComponent(context, word) {

    var width = 0, height = 0;
    const mediatype = context.data.get('mediaType') || 'mobile';
    this.container = context.add.container(0, 0, []);
    const fontStyle=WORD_BOX_STYLE.fontStyle[mediatype]
    const letterList = [];
    const letterSize = parseInt(fontStyle.fontSize);
    const boxConfig = {
        width: letterSize + WORD_BOX_STYLE.padding.x * 2,
        height: letterSize + WORD_BOX_STYLE.padding.y * 2,
        borderRadius: WORD_BOX_STYLE.borderRadius,
    };
    const letterGap = WORD_BOX_STYLE.letterGap[mediatype]

    // CREATE BOX TEXTURES TO BE REUSE
    createBox("bg-box-default", context, WORD_BOX_STYLE.backgroundColor, boxConfig);
    createBox("bg-box-alter", context, Number(fontStyle.color.replace("#", "0x")), boxConfig);

    for (let i in word) {
        if (word[i].trim() === "") {
            width += parseInt( fontStyle.fontSize) - letterGap;

        } else {
            const letter = new LetterComponent(context, word[i]);
            letter.container.setX(width);
            width += letter.width + letterGap;
            height = letter.height;

            letterList.push(letter);
            this.container.add(letter.container);
        }
    }

    this.container.setSize(width, height);
    this.container.setInteractive();
    this.width = width;
    this.height = height;

    // FOR DEBUG
    // var border_graphics = context.add.graphics();

    // border_graphics.lineStyle(2, 0xffff00);
    // border_graphics.strokeRect(0, 0, width, height);
    // border_graphics.setVisible(false);
    // this.container.add(border_graphics);


    const animate_manager = new BlinkManager(letterList, context.tweens);


    this.setVisibleLetters = (visible) => {

        this.container.list.forEach((child) => {
            if (child.text) {
                child.text.setVisible(visible);
            }
        })
    }
    this.blankState = () => {
        this.setVisibleLetters(false);
    };

    this.fillState = () => {
        this.setVisibleLetters(true);
    };
    this.highlight = (state) => {

        this.container.setScale(state ? 1.01 : 1)
        animate_manager.highlight(state);

    }
    this.dropedState = () => {
        this.fillState();
        animate_manager.blinkOnce();

    }
    this.blinkState = () => {
        animate_manager.blink(10);
    }
};
export default WordComponent;